"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenSources = void 0;
const TOKEN_SOURCE_USER = "user";
const TOKEN_SOURCE_IPAD = "ipadapp";
const TOKEN_SOURCE_INVITE = "invitation";
const TokenSources = {
    TOKEN_SOURCE_USER,
    TOKEN_SOURCE_IPAD,
    TOKEN_SOURCE_INVITE,
};
exports.TokenSources = TokenSources;
